import { useQuery } from '@tanstack/react-query';

import { exchangeRateQueries } from '#exchange-rates';

export function useExchangeRates() {
  return useQuery(exchangeRateQueries.list());
}
